module.exports = __webpack_public_path__ + "logo-orkla-tagline-fi-white-8cbb43497c7058927935c78c90d23062.png";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/logo-orkla-tagline-fi-white.png
// module id = 64
// module chunks = 0